import { Node, mergeAttributes } from '@tiptap/core'
import { store } from '@/store'
import router from '@/router'

export const LocalLink = Node.create({
  name: 'localLink',

  defaultOptions: {
    HTMLAttributes: {}
  },

  group: 'inline',
  inline: true,
  selectable: false,
  atom: true,

  addAttributes () {
    return {
      label: {
        default: null
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'button.localLink',
        getAttrs: node => {
          return { label: node.innerText }
        }
      }
    ]
  },

  renderHTML ({ node, HTMLAttributes }) {
    return ['button', mergeAttributes(
      this.options.HTMLAttributes,
      HTMLAttributes,
      { class: 'localLink' }
    ), node.attrs.label]
  },

  addNodeView () {
    return ({ node }) => {
      const dom = document.createElement('button')

      dom.classList.add('localLink')

      const open = () => {
        if (router.currentRoute.value.name !== 'Share') {
          store.commit('changeActiveState', 'Plans')
          store.commit('toggleSettingsModal', true)
          store.commit('toggleAside', false)
        }
      }

      dom.addEventListener('click', open)

      dom.innerHTML = node.attrs.label

      return {
        dom,
        destroy () {
          dom.removeEventListener('click', open)
        }
      }
    }
  }
})
